import { firestore } from './config';
import { firestoreCollections } from 'constants/firebaseConstant';

const queryRef = {
  ADMIN_USER: firestore.collection(firestoreCollections.ADMIN_USER),
  APP_USERS: firestore.collection(firestoreCollections.APP_USERS),
  USER_INFO_BY_ID: userId => firestore.collection(firestoreCollections.ADMIN_USER).doc(userId),
  EVENTS: firestore.collection(firestoreCollections.EVENTS),
  EVENT_LOCATIONS: firestore.collection(firestoreCollections.EVENT_LOCATIONS),
  INVITED_CLIENTS: firestore.collection(firestoreCollections.INVITED_CLIENTS),
  INVITED_CLIENTS_BY_ID: userId => firestore.collection(firestoreCollections.INVITED_CLIENTS).doc(userId),
  PAYMENT_LOG: firestore.collection(firestoreCollections.PAYMENT_LOG),
  REVENEW_SPLIT_LOG: firestore.collection(firestoreCollections.REVENEW_SPLIT_LOG),
};

export default queryRef;
